import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';
import paperPlanes from '../images/paperPlanes.png';
import creditDistribution from '../images/creditDistribution.jpg';
import baseMonetisation from '../images/baseMonetisation.jpg';
import funnelConversion from '../images/funnelConversion.jpg';
import innovationIcon from '../images/innovationIcon.png';
import berryClub from '../images/theBerryClub.png';
import bookberryClub from '../images/bookberryClub.png';
import './transitions.css';
import CustomButton from './CustomButton';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const ServiceCard = ({ title, description, imageSrc }) => (
  <div 
    className="bg-white w-full xs:w-[300px] sm:w-[320px] md:w-[280px] lg:w-[300px] xl:w-[320px] shadow-[0_4px_20px_rgba(0,0,0,0.1)] mx-auto" 
    style={{
      borderTopRightRadius: '40px',
      borderBottomLeftRadius: '40px',
      borderTopLeftRadius: '0px',
      borderBottomRightRadius: '0px'
    }}
  >
    <div className="mb-4 overflow-hidden relative pb-[60%]" 
      style={{ borderTopRightRadius: '40px' }}
    >
      <img 
        src={imageSrc} 
        alt={title}
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
    </div>
    <div className="text-center px-4 xs:px-5 sm:px-6 pb-6">
      <h3 className="font-bold text-sm xs:text-base sm:text-lg mb-3 font-roboto text-[#003B5C]">
        {title}
      </h3>
      <p className="text-xs xs:text-sm leading-relaxed font-roboto text-gray-600">
        {description}
      </p>
    </div>
  </div>
);



function Website() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const images = {
    logo, paperPlanes, creditDistribution, baseMonetisation,
    funnelConversion, berryClub, bookberryClub, innovationIcon
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.querySelector('.section-content').classList.add('visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.scroll-section').forEach(section => {
      sectionObserver.observe(section);
    });

    return () => sectionObserver.disconnect();
  }, []);

  const scrollToSection = (sectionNumber) => {
    const section = document.querySelector(`[data-section="${sectionNumber}"]`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="scroll-container">
      {/* Hero Section */}
      <section 
        className="scroll-section relative" 
        data-section="0" 
        style={{ backgroundColor: '#7ce7ca' }}
      >
        <div className="section-content min-h-screen">
          {/* Content Structure */}
          <div className="min-h-screen flex flex-col md:flex-row items-center justify-center px-3 xs:px-4 sm:px-6 md:px-8 lg:px-12">
            <div className="w-full flex flex-col md:flex-row items-center justify-center gap-6 xs:gap-8 md:gap-0">
              {/* Text Container */}
              <div className="w-full md:w-1/2 order-1 mt-16 xs:mt-18 sm:mt-20 md:mt-0">
                <div className="text-center md:text-center">
                  <h2 className="text-[#060644] text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-[80px] leading-tight mb-6 xs:mb-8">
                    <span className="font-roboto font-normal">navigating</span><br />
                    <span className="font-roboto font-bold">new horizons</span>
                  </h2>
                  
                  <div className="flex flex-col xs:flex-row gap-3 xs:gap-4 justify-center mb-8 xs:mb-10 sm:mb-12 md:mb-0">
                    <CustomButton onClick={() => scrollToSection(1)}>
                      Innovation
                    </CustomButton>
                    <CustomButton onClick={() => scrollToSection(2)}>
                      Consulting
                    </CustomButton>
                  </div>
                </div>
              </div>

              {/* Image Container */}
              <div className="w-full md:w-1/2 order-2 mt-4 md:mt-0">
                <img 
                  src={images.paperPlanes} 
                  alt="Paper airplanes"
                  className="w-full max-w-[280px] xs:max-w-[320px] sm:max-w-lg md:max-w-full h-auto object-contain mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Innovation Section */}
      <section className="scroll-section" data-section="1" style={{ backgroundColor: '#f3f4f6' }}>
        <div className="section-content">
          <div className="max-w-7xl mx-auto px-3 xs:px-4 sm:px-6 lg:px-8 pt-12 xs:pt-14 sm:pt-16 md:pt-20 lg:pt-24 pb-12 xs:pb-14 sm:pb-16 md:pb-20 lg:pb-24">
            <div className="flex flex-col md:flex-row gap-6 xs:gap-8 md:gap-12">
              <div className="w-full md:w-1/2 relative z-10">
                <h2 className="text-xl xs:text-2xl sm:text-3xl md:text-[44px] font-bold text-[#003B5C] mb-4 font-roboto text-center md:text-left">
                  innovation by novecta
                </h2>
                <p className="text-base xs:text-lg sm:text-xl md:text-[20px] text-gray-700 mb-6 xs:mb-8 md:mb-12 max-w-xl font-roboto font-normal text-center md:text-left">
                  crafting innovative solutions that are transcending the physical-digital divide. we are creating seamless experiences that are unifying the tangible and virtual worlds effortlessly.
                </p>

                {/* White Card */}
                <div className="w-full lg:w-[600px]">
                  <div className="p-4 xs:p-5 sm:p-6 md:p-7 lg:p-8 shadow-md mx-auto"
                    style={{
                      borderRadius: '40px',
                      backgroundColor: '#f1958b'
                    }}
                  >
                    <div className="flex flex-col items-center gap-6 xs:gap-7 sm:gap-8">
                      <div className="w-full max-w-[280px] xs:max-w-[300px] sm:max-w-[320px] md:max-w-[350px]">
                        <img 
                          src={images.berryClub}
                          alt="The Berry Club"
                          className="w-full h-auto drop-shadow-2xl rounded-[40px]"
                        />
                      </div>

                      <div className="w-full max-w-[280px] xs:max-w-[300px] sm:max-w-[320px] md:max-w-[350px]">
                        <img 
                          src={images.bookberryClub}
                          alt="bookberry.club"
                          className="w-full h-auto drop-shadow-2xl rounded-[40px]"
                        />
                      </div>

                      <div className="flex justify-center w-full">
                        <CustomButton onClick={() => navigate('/innovation')}>
                          know more
                        </CustomButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="w-full md:w-1/2 flex justify-center items-center mt-8 md:mt-16">
                <img 
                  src={images.innovationIcon}
                  alt="Innovation Icon"
                  className="w-48 xs:w-56 sm:w-64 md:w-80 lg:w-96 h-48 xs:h-56 sm:h-64 md:h-80 lg:h-96 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Consulting Section */}<section className="scroll-section" data-section="2" style={{ backgroundColor: '#eee75c' }}>
        <div className="section-content">
          <div className="max-w-7xl mx-auto px-3 xs:px-4 sm:px-6 lg:px-8 pt-12 xs:pt-14 sm:pt-16 md:pt-20 pb-12 xs:pb-14 sm:pb-16 md:pb-20">
            <div className="mb-8 xs:mb-10 sm:mb-12 text-center md:text-left">
              <h2 className="text-xl xs:text-2xl sm:text-3xl md:text-[44px] font-bold mb-4 font-roboto text-[#003B5C]">
                consulting by novecta
              </h2>
              <p className="text-base xs:text-lg sm:text-xl md:text-[20px] text-gray-600 max-w-7xl font-roboto font-normal">
                we offer a comprehensive range of business consulting services to help your company thrive. we work closely with you to develop and implement tailored strategies that drive growth and success.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xs:gap-8 sm:gap-12 lg:gap-24 mb-12 xs:mb-14 sm:mb-16">
              <ServiceCard
                title="credit distribution"
                description="we develop and implement effective strategies and networks for distributing credit products to target markets"
                imageSrc={images.creditDistribution}
              />
              <ServiceCard
                title="base monetisation"
                description="our monetization services help lenders, merchants, and consumer platforms unlock new revenue streams"
                imageSrc={images.baseMonetisation}
              />
              <ServiceCard
                title="funnel conversion"
                description="we specialize in improving customer acquisition and conversion rates for businesses offering instant credit solutions"
                imageSrc={images.funnelConversion}
              />
            </div>

            <div className="flex justify-center pb-12 xs:pb-14 sm:pb-16 md:pb-20">
              <CustomButton onClick={() => navigate('/contact')}>
                contact us
              </CustomButton>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </div>
  );
}

export default Website;